<template>

  <div class="container" id="blogContainer">
    <h2 class="light dark mb-0">Blog <span class="bold">Artikel</span></h2>

    <div class="row" v-if="selectedArticle">
      <div class="col-12">
        <h4 class="mt-5 mb-1">{{selectedArticle.headline}}</h4>
        <p class="mb-2"><small><i>von Nicolas Mandt am {{new Date(selectedArticle._created * 1000).toLocaleDateString()}}</i></small></p>
        <div class="row">
          <div class="col-12 col-md-4">
            <img class="mb-2 img-fluid" :src="baseUrl + selectedArticle.image.path" alt="Article image">
          </div>          
        </div>
        <p class="mb-2" v-html="selectedArticle.article" />

        <a href="#" class="button button-2 mt-3" @click="selectedArticle=null;">Zurück zur Übersicht</a>

        <h4 class="mt-5" style="margin-bottom:15px;">Weitere <span class="bold">Artikel</span></h4>
      </div>
    </div>

    <div class="row mt-3">

    <template v-for="(item, index) in collection">
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-5" :key="item._id" v-if="!item.hide && (!selectedArticle || item._id != selectedArticle._id)">
        <div class="card">
          <img class="card-img-top" :src="baseUrl + item.image.path" alt="Article image">
          <div class="card-body">
            <h5 class="card-title">{{item.headline}}</h5>
            <p class="card-text" v-html="item.intro"></p>
            <p><small><i>von Nicolas Mandt am {{new Date(item._created * 1000).toLocaleDateString()}}</i></small></p>
            <a :href="'/blog?id=' + item._id" class="btn btn-primary mt-2">Mehr lesen</a>
          </div>
        </div>
      </div>
    </template>

    </div>

  </div>

</template>

<script>

    export default {
        components:{

        },
        data() {
            return {
              collection:[],
              selectedArticle: null,
            }
        },
        mounted () {
          this.$http.get(this.$store.getters.serviceClient().getCollectionUrl('contentBlog'))
            .then((response) => {
              if (response.ok) {
                console.log(response.body.entries)
                this.$data.collection = response.body.entries

                if(this.$route.query.id){
                  let searchId = this.$route.query.id;
                  for(let article of this.$data.collection){
                    if(article._id == searchId){
                      this.$data.selectedArticle = article;
                      break;
                    }
                  }
                }
              }
            })
            .catch((error) => {
              console.log(error)
            })
        },
        props: [],
        computed: {
          baseUrl () {
            return this.$store.getters.baseUrl()
          }
        },
        methods: {}
    }

</script>

<style scoped="scoped">
  #blogContainer{
    color:#666;
    padding-top:5em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Blog.vue